export default __webpack_public_path__ + "static/media/logoBottom.73b8e432.svg";